module.exports = "/assets/data/8206ef2144fe8a56db1fb251e2dbf5d4-NE9.data.json";